import { createPortal } from 'react-dom';

export const BIG_ITEM_LOADING_MESSAGE = 'Cargando datos...';

/** Mismo overlay global, con ciclo de vida independiente de las acciones imperativas. */
export default function FullScreenLoader({ active, message = 'Cargando información...' }) {
  if (!active) return null;
  return createPortal(
    <div className="global-loader" role="status" aria-live="polite" aria-busy="true">
      <div className="global-loader-box">
        <span className="spinner-dark" aria-hidden="true" />
        <span>{message}</span>
      </div>
    </div>, document.body,
  );
}
